import useMsiEffectTitle from '../../hooks/useMsiEffectTitle'

// AI-CONTEXT: See docs/pitfalls.md#state-firestore-lookup-empty-in-template-mode

/**
 * Title shown above a research-card chart for MSI-effect fields.
 *
 * Regular (non-MSI) questionnaire fields already show their title via
 * `QuestionMeta` (`field.Question`). MSI-effect fields (`Standard === 'true'`)
 * are blanked there because their `Question` is empty/generic — the real name
 * lives on the linked `OutputEffects` doc (`Effect`). This resolves that doc
 * and renders its name, so the viewer knows which effect the graph is about.
 *
 * Renders nothing when there is no linked effect (i.e. non-MSI fields), so it
 * is safe to render unconditionally next to `QuestionMeta`.
 *
 * @param {object} props
 * @param {string | string[]} [props.effectId] - The field's `EffectId` (array of `OutputEffects` IDs, or a single ID).
 * @param {string} [props.className] - Overrides the styling hook; defaults to the research-card title style.
 */
const MsiEffectTitle = ({ effectId, className }) => {
    const title = useMsiEffectTitle(effectId)

    if (!title) return null

    return <p className={className || 'research-card-effect-title'}>{title}</p>
}

export default MsiEffectTitle
